<template>
  <img
    :srcset="
      `
        ${image.medium_large} 768w,
        ${image.large} 1200w,
        ${image.full} 1920w
    `
    "
    sizes="(max-width: 768px) 768px,
           (min-width: 768px and max-width: 1200px) 1200px,
           1920px"
    :src="image.full"
    class="img-fluid gallery-image"
  />
</template>

<script>
export default {
  name: 'GalleryImage',
  props: {
    image: {
      type: Object,
      reqierd: true,
    },
  },
};
</script>
